<template>
  <div class="" v-if="broker != null">
    <div class="text-base text-center">
      First step! Let's start with some basics.
    </div>

    <div class="flex flex-wrap -mx-2 mt-8">
      <div class="w-1/3 px-2">
        <TitleSelector 
          propertyKey="title"
          objectType="application"
          objectSubType="profile"
          :value="application.title"
          :updateValue="updateValue" />
      </div>

      <div class="w-1/3 px-2">
        <InputText 
          label="First name" 
          propertyKey="firstName"
          objectType="application"
          objectSubType="profile"
          :value="application.firstName"
          :updateValue="updateValue" />
      </div>

      <div class="w-1/3 px-2">
        <InputText 
          label="Last name" 
          propertyKey="lastName"
          objectType="application"
          objectSubType="profile"
          :value="application.lastName"
          :updateValue="updateValue" />
      </div>
    </div>


    <div class="flex flex-wrap -mx-2 mt-8">
      <div class="w-1/3 px-2">
        <div class="label-standard">
          Date of birth
        </div>

        <div class="form-line">
          <vue-pikaday 
            v-model="application.bornAt" 
            :options="dateOptions"
            class="input-standard" />
        </div>
      </div>

      <div class="w-1/3 px-2">
        <div class="label-standard">
          Gender
        </div>        

        <div class="mt-2">
          <select 
            :value="application.gender == null ? -1 : application.gender"
            v-on:change="updateValue({
              objectType: 'person',
              key       : 'gender',
              value     : $event.target.value
            })"
            class="select-standard">
            <option value="-1" disabled="">Select an option...</option>
            <option value="0">Male</option>
            <option value="1">Female</option>
          </select>
        </div>
      </div>

      <div class="w-1/3 px-2">
        <div class="label-standard">
          Marital status
        </div>        

        <div class="mt-2">
          <select 
            :value="application.marital_status == null ? -1 : application.marital_status"
            v-on:change="updateValue({
              objectType: 'application',
              key       : 'marital_status',
              value     : $event.target.value
            })"
            class="select-standard">
            <option value="-1" disabled="">Select an option...</option>
            <option value="0">Single</option>
            <option value="1">Married</option>
            <option value="2">DeFacto</option>
            <option value="3">Divorced</option>
            <option value="4">Widowed</option>
            <option value="5">Separated</option>
          </select>
        </div>
      </div>
    </div>

    <div class="text-center mt-20 flex items-center justify-center">
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-gray-400 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-gray-400 w-3 h-3 rounded-full"></div>
    </div>

    <div class="mt-4 text-xs">
      <table class="w-full">
        <tr>
          <td class="w-1/3">
            <router-link 
              :to="{
                name  : 'broker-onboard-home',
                params: {
                  brokerId   : $route.params.brokerId
                }
              }"
              tag="a" 
              class="rounded px-4 py-2 text-xs bg-gray-500 hover:bg-gray-600 text-white float-left">
              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
              </svg>
              Back
            </router-link>
          </td>
          <td class="w-1/3">
            <div class="text-gray-600 text-center">Step 1 of 3</div>
          </td>
          <td class="w-1/3 text-right">
            <button
              @click.prevent="next()"
              :class="{ 
                'rounded px-4 py-2 text-xs float-right'    : true,
                'bg-blue-500 hover:bg-blue-600 text-white' : broker.logo != null,
                'bg-gray-500 hover:bg-gray-600 text-white' : broker.logo == null
              }">

              <span class="float-left">Next</span>

              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
              </svg>
            </button>
          </td>
        </tr>
      </table>
    </div>

    <!-- <OneModal /> -->
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import TitleSelector  from '@/shared/components/form/TitleSelector'
  import InputText      from '@/shared/components/form/InputText'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import InputRadio     from '@/shared/components/form/InputRadio'
  // import OneModal       from './OneModal'

  // import InputDatePickerReadOnly from '@/shared/components/form/InputDatePickerReadOnly'
  
  export default {

    components: {
      TitleSelector,
      InputText,
      SubmitButton2,
      // InputDatePickerReadOnly,
      InputRadio,
      // OneModal
    },

    data () {
      return {
        loading    : false,
        broker     : null,
        uploaded   : false,
        application: {
          title        : null,
          firstName    : null,
          lastName     : null,
          bornAt       : null,
          marital_status: null
        },

        dateOptions: {
          format: 'DD/MM/YYYY',
          // minDate    : this.minDate != null ? moment(this.minDate, 'YYYY-MM-DD').toDate() : null,
          // maxDate    : this.maxDate != null ? moment(this.maxDate, 'YYYY-MM-DD').toDate() : null,
          // defaultDate: this.defaultYearDiff != null ? moment().add(this.defaultYearDiff, 'years').toDate() : moment().toDate(),
          // yearRange  :100
        }
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })

      if(this.$route.params.data != null) {
        this.application = JSON.parse(decodeURIComponent(this.$route.params.data))
      }
    },

    methods : {
      updateValue(params) {
        this.application[params.key] = params.value
      },
      
      next() {
        // console.log(this.application)
        // this.$modal.show('one-modal')
        // if(this.broker.logo != null) {
          this.$router.push({
            name  : 'broker-onboard-first-client-two',
            params: {
              brokerId: this.broker.id,
              data    : encodeURIComponent(JSON.stringify(this.application))
            }
          })
        // }

        // else {
        //   this.$modal.show('confirm-modal', {
        //     // width : 600,
        //     title  : "Are you sure?",
        //     message: "Are you sure you want to proceed without uploading a logo?",
        //     buttons:[{
        //       label          : 'Yes',
        //       color          : 'green',
        //       loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
        //       action         : () => {
        //         this.$modal.hide('confirm-modal')
        //         this.$router.push({
        //           name  : 'broker-onboard-personalize-two',
        //           params: {
        //             brokerId : this.broker.id
        //           }
        //         })
        //       }
        //     }, {
        //       label : 'No',
        //       color : 'gray',
        //       action: () => {
        //         this.$modal.hide('confirm-modal')
        //       }
        //     }]
        //   })
        // }
      }
    },
  }
</script>